import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dentists',
  templateUrl: './dentists.component.html',
  styleUrls: ['./dentists.component.scss']
})
export class DentistsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
